<template>
    <div :id="modalId" class="modal fade " tabindex="-1" role="dialog" aria-hidden="false">
        <div class="modal-dialog" :class="dialogClass" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modalTitre ? modalTitre : isEditMode ? "Edition" : "Ajout" }}</h5>
                    <a data-bs-dismiss="modal">
                        <i :id='modalId + "close"' class="material-icons" style="font-size:20px;color:grey">close</i>
                    </a>
                </div>
                <div class="modal-body">
                    <slot></slot>
                    <br>
                    <div class="error" v-if="errors.length">
                        <p>Merci de corriger les erreurs suivantes</p>
                        <ul>
                            <li v-for="error in errors" :key="error.message">
                                {{ error.message }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="modal-footer">
                    <button @click="saveModal()" type="button" class="btn btn-primary"> {{ isEditMode ? "Modifier" :
                        "Sauvegarder" }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'modalEdition',
    props: {
        modalId: { String, required: true },
        isEdition: Boolean,
        modalTitre: String,
        dialogClass: {
            type: String,
            default: 'modal-dialog modal-l' 
        }
    },
    data() {
        return {
            errors: []
        }
    },
    computed: {
        isEditMode() {
            return this.isEdition;
        },
        getIdModalName() {
            return this.idModalName;
        }
    },
    methods: {
        saveModal() {
            this.errors = [];
            this.$emit("save");
        },
        closeModal() {
            document.getElementById(this.modalId + "close").click();
        },
        errorMessage(errors) {
            this.errors = errors;
        }
    }
};
</script>
<style>
.modal-header {
    display: flex;
    justify-content: space-between;
}

.error {
    color: red;
}
</style>